import script from "./CaptioningDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptioningDashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__